import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-grow flex flex-col min-h-0 gap-y-2" }
const _hoisted_2 = { class: "flex-grow flex flex-col min-h-0 gap-y-2" }
const _hoisted_3 = { class: "items-center" }
const _hoisted_4 = { class: "flex gap-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_ApprovalResultDefault = _resolveComponent("ApprovalResultDefault")!
  const _component_ApprovalResultNotFound = _resolveComponent("ApprovalResultNotFound")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      class: "py-2 px-3 flex-grow flex flex-col min-h-0",
      rounded: "lg",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Search, {
                id: "search-login-approval",
                onInput: _ctx.onSearch,
                onClear: _ctx.clearSearch,
                value: _ctx.search,
                class: "w-300px",
                placeholder: "Cari nama user / device / kode"
              }, null, 8, ["onInput", "onClear", "value"]),
              _createVNode(_component_time_range_picker, {
                id: "time-range-picker-login-approval",
                startDate: _ctx.startDate,
                endDate: _ctx.endDate,
                maxDate: _ctx.getFormattedDate(),
                onSelect: _ctx.setDateRange,
                default: "7 hari terakhir",
                showOptions: "custom, hari ini, 7 hari terakhir, 14 hari terakhir"
              }, null, 8, ["startDate", "endDate", "maxDate", "onSelect"])
            ])
          ]),
          (
            _ctx.loginApprovalDevicesList.length === 0 &&
              _ctx.search === '' &&
              !_ctx.isLoading &&
              !_ctx.errorCause
          )
            ? (_openBlock(), _createBlock(_component_ApprovalResultDefault, {
                key: 0,
                message: "Belum ada data informasi perangkat tim Anda."
              }))
            : (
            _ctx.loginApprovalDevicesList.length === 0 &&
              _ctx.search !== '' &&
              !_ctx.isLoading &&
              !_ctx.errorCause
          )
              ? (_openBlock(), _createBlock(_component_ApprovalResultNotFound, { key: 1 }))
              : (_openBlock(), _createBlock(_component_TableV2, {
                  key: 2,
                  pagination: _ctx.pagination,
                  "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
                  loading: _ctx.isLoading,
                  columns: _ctx.columns,
                  class: "my-2 rounded-xl",
                  errorCause: _ctx.errorCause,
                  isShowTryAgainBtn: "",
                  onTryAgain: _ctx.fetchLoginApproval,
                  data: _ctx.loginApprovalDevicesList,
                  borderTop: false,
                  totalColumnFreeze: 0,
                  pinnedSubstractHeight: "280px",
                  paginationStyle: "v3",
                  bgHeader: "bg-white",
                  isBorderOnHeadBgWhite: "",
                  isNoPaddingBottom: "",
                  customClassPagination: "w-full h-full flex items-end px-3",
                  isSpaceTop: false,
                  headerTextColor: "text-black-lp-200",
                  onRequest: _ctx.fetchLoginApproval
                }, null, 8, ["pagination", "loading", "columns", "errorCause", "onTryAgain", "data", "onRequest"]))
        ])
      ]),
      _: 1
    })
  ]))
}